<template>
  <v-menu
    v-bind="menuAttrs"
    :content-class="mergedContentClass"
    v-on="$listeners"
  >
    <template
      v-if="$scopedSlots.activator"
      #activator="slotProps"
    >
      <slot
        name="activator"
        v-bind="slotProps"
      />
    </template>
    <slot />
  </v-menu>
</template>

<script>
export default {
  name: 'VMenuWrapper',
  inheritAttrs: false,

  computed: {
    // Strip out any consumer-supplied content-class so it can't silently
    // replace `mergedContentClass` below via the v-bind spread.
    menuAttrs () {
      const { contentClass, 'content-class': contentClassKebab, ...rest } = this.$attrs
      return rest
    },

    // Every v-menu-wrapper gets rounded corners by default (see the unscoped
    // style below) - merge in any content-class a consumer also passes (eg.
    // for a one-off z-index fix) instead of letting it replace ours.
    mergedContentClass () {
      const custom = this.$attrs.contentClass || this.$attrs['content-class'] || ''
      return ['v-menu-wrapper__content', custom].filter(Boolean).join(' ')
    }
  }
}
</script>

<style>
/* Unscoped: v-menu detaches its content and appends it to [data-app], so it's
   never a DOM descendant this component's scoped styles could reach. */
.v-menu-wrapper__content {
  border-radius: 16px !important;
}
</style>
